import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { OrientationType, ScreenOrientation } from '@capawesome/capacitor-screen-orientation';
import { useSize } from 'ahooks';
import { useLocation } from 'react-router';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import ScreenFlipTip from '@/pages/user/search-member/screen-flip-tip';
import { selectDevicePlatform } from '@/store/device';
import { When } from '@/components';
import Header from '@/pages/ai-consultation/components/header';
import { useNav } from '@/hooks';
import { ALL_PAGES, JUDGE_AS_VERTICAL_SCREEN_HEIGHT } from '@/constant';

import cx from './index.module.scss';

interface Props {}

const IframeContent: React.FC<Props> = () => {
  const devicePlatform = useSelector(selectDevicePlatform);
  const nav = useNav();
  const [isTipOpen, setIsTipOpen] = useState(false);
  const [isInitOK, setIsInitOK] = useState(false);
  const iframeRef = useRef(null);
  const sizeRef = useRef(null);
  const screenSize = useSize(sizeRef);
  const location = useLocation();

  const isVerticalScreen = useMemo(() => screenSize?.height > JUDGE_AS_VERTICAL_SCREEN_HEIGHT, [screenSize?.height]);

  const onIframeLoadOK = useCallback(() => {
    setIsInitOK(true);
  }, []);

  useEffect(() => {
    if (devicePlatform === 'android') {
      ScreenOrientation.lock({ type: OrientationType.PORTRAIT_PRIMARY });
      return () => {
        ScreenOrientation.lock({ type: OrientationType.LANDSCAPE_PRIMARY });
      };
    }
  }, [devicePlatform]);

  useEffect(() => {
    if (isTipOpen && isVerticalScreen && devicePlatform === 'android') {
      setIsTipOpen(false);
    }
    if (!isVerticalScreen && devicePlatform === 'android') {
      setIsTipOpen(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVerticalScreen, isTipOpen, devicePlatform]);

  return (
    <div className={cx('IframeContent')} ref={sizeRef}>
      <div className={cx('iframe-content-header')}>
        <Header
          showBorder={false}
          backConfig={{ text: '返回', action: () => nav(ALL_PAGES.HELP_FEEDBACK) }}
          title={location?.state?.title}
        />
      </div>
      <When condition={!!location?.state?.iframeUrl}>
        <div className={cx('iframe-page-content')}>
          <When condition={!isInitOK}>
            <div className={cx('loading')}>
              <Loading3QuartersOutlined spin className={cx('icon')} />
            </div>
          </When>
          <iframe
            ref={iframeRef}
            allowFullScreen
            onLoad={onIframeLoadOK}
            src={location?.state?.iframeUrl}
            className={cx('iframe')}
          />
        </div>
      </When>

      <ScreenFlipTip
        tipText="为了您更好的浏览文档，请将屏幕进行旋转"
        open={isTipOpen}
        setOpen={setIsTipOpen}
        onClickOK={() => nav(ALL_PAGES.HELP_FEEDBACK)}
      />
    </div>
  );
};

export default IframeContent;
